import React, { useState, useEffect } from "react";
import "./beauty.css";
import belly from "../../assets/belly.png";
import { Link } from "react-router-dom";
import axios from "axios";

const SexCont = ({selectedTool, setSelectedTool}) => {
  const [activeTab, setActiveTab] = useState(1);
  const [expandedItem, setExpandedItem] = useState(null);
  const [dosdonts, setData] = useState([]);
  const [values, setValues] = useState({ id: 61 });

  useEffect(() => {
    axios
      .post("https://musicplayer.preggyzone.com/api/get_dosdonts_list", values)
      .then((response) => {
        if (Array.isArray(response.data.data)) {
          const parsedData = response.data.data.map((item) => {
            const doc = new DOMParser().parseFromString(
              item.description,
              "text/html"
            );

            const plainText = doc.body.textContent || doc.body.innerText;

            const decodedText = new DOMParser().parseFromString(
              plainText,
              "text/html"
            ).documentElement.textContent;

            return {
              ...item,
              description: decodedText,
            };
          });
          setData(parsedData);
        } else {
          console.error(
            "Expected data to be an array but got:",
            response.data.data
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data from the API:", error);
      });
  }, []);

  const handleTabClick = (tab) => setActiveTab(tab);

  const toggleItem = (id) => setExpandedItem(expandedItem === id ? null : id);

  const filteredItems = dosdonts.filter((item) => item.types_id === activeTab);

  const getBackgroundClass = () => {
    switch (activeTab) {
      case 1:
        return "safe-bg";
      case 2:
        return "warning-bg";
      case 3:
        return "danger-bg";
      default:
        return "";
    }
  };

  return (
    <div className="beauty-base">
      <div className="beauty-cont">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/dos-donts" className="breadcrumb-link">
                  Dos...
                </Link>
              </li>
              <li className="breadcrumblist active">Conception</li>
            </ol>
          </nav>
        </div>

        <div className={`beauty-style-container ${getBackgroundClass()}`}>
          <h2>Conception</h2>
          <div className="tabs">
            {[1, 2, 3].map((tab) => (
              <button
                key={tab}
                className={`tab-button ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab === 1 ? "Do' s" : tab === 2 ? "Warning" : "Dont's"}
              </button>
            ))}
          </div>
          <div className="item-list">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                className={`item ${expandedItem === item.id ? "expanded" : ""}`}
                onClick={() => toggleItem(item.id)}
              >
                <div className="item-header">
                  <span style={{ color: "black" }}>{item.name}</span>
                  <span className="toggle-icon">
                    {expandedItem === item.id ? "▲" : "▼"}
                  </span>
                </div>
                <div
                  style={{ marginTop: "20px" }}
                  className={`item-details ${
                    expandedItem === item.id ? "show" : ""
                  }`}
                >
                  {expandedItem === item.id && (
                    <div className="toggle-lists">
                      <h4 style={{ textAlign: "center" }} className="p">
                        {item.short_desc}
                      </h4>
                      <img
                        src={item.img_url || belly}
                        alt={item.name}
                        className="item-image"
                      />
                      <div style={{ padding: "20px 0px" }}>
                        <p style={{ textAlign: "justify", lineHeight: "25px" }}>
                          {item.description}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SexCont;
